import {
  CancellationNavigationEnum,
  ContractingCancellationStateEnum,
} from 'v3/data/store/cancellationNavigation/enum';

type MappingValue = {
  title: string;
};

type CancellationStateMapping = Record<ContractingCancellationStateEnum, MappingValue>;

export const CancellationStateMapping: CancellationStateMapping = {
  [ContractingCancellationStateEnum.CANCELLATION_STARTED]: {
    title: 'Cancelamento Iniciado',
  },
  [ContractingCancellationStateEnum.PROCESSING_CANCELLATION]: {
    title: 'Processando Cancelamento',
  },
  [ContractingCancellationStateEnum.CANCELLATION_FINISHED]: {
    title: 'Cancelamento Finalizado',
  },
};

export const CancellationStateMappingDisableToCancel = [
  CancellationNavigationEnum.PROCESSING_CANCELLATION,
  CancellationNavigationEnum.CANCELLATION_FINISHED,
];
